import { jusIAPersistentAlertBannerPersisted } from '@jusbrasil-web/shared-persistent-alert-banner'
import { parseUserCookie } from '@jusbrasil-web/shared-user-session'
import { getCookie } from '@jusbrasil-web/shared-utils-cookies'
import { GetServerSidePropsContext } from 'next'

import { SHOW_JUSIA_ON_TOPBAR_BASED_ON_SUBSCRIPTION } from '../../constants'
import { TopbarContextType } from '../../types'
import { TOPBAR_NEXT_INTERNAL_KEY } from '../constants'
import { WithTopbarPropsReturn } from '../types'

// IMPORTANT: Never make this function async. This function is part of the server-side rendering (SSR) process,
// and making it async would increase response time, negatively impacting performance. All data-fetching
// is intentionally handled client-side to ensure faster server responses. DO NOT delay the response time! @andersonba
export function withTopbarProps(
  ctx: Pick<GetServerSidePropsContext, 'req' | 'resolvedUrl'>
): WithTopbarPropsReturn {
  const { req } = ctx
  if (!req) {
    console.warn(
      `No request detected, withTopbarProps (@jusbrasil-web/shared-topbar) expects to be used on pages with getServerSideProps, even if setup on custom documents getInitialProps`
    )
    return {}
  }

  const userCookie = parseUserCookie(ctx)
  const logged = userCookie?.pid !== undefined
  const currentUrl = `https://${req.headers.host}${ctx.resolvedUrl}`

  const userIntentionsCookie = getCookie(req, 'user_intentions') ?? ''
  const isInvolvedPartyLawsuit = ['PARTY', 'RELATIVE'].includes(userIntentionsCookie)
  const shouldShowJusIABasedOnCurrentSubscription =
    getCookie(req, SHOW_JUSIA_ON_TOPBAR_BASED_ON_SUBSCRIPTION.cookie.name) === 'true'

  const hasInteractedWithJusIAAlert = !!jusIAPersistentAlertBannerPersisted.get(
    userCookie?.pid?.toString(),
    req
  )

  // topbar ui context
  const context: TopbarContextType = {
    logged,
    currentUrl,
    // do not use async data-fetching for flags, cookies dependency is recommended
    flags: {
      isInvolvedPartyLawsuit,
      shouldShowJusIABasedOnCurrentSubscription,
      hasInteractedWithJusIAAlert,
    },
  }

  // [TODO] it's temporary until we rollout the feature flag. @andersonba
  const extraProps: Record<string, unknown> = {}
  if (getCookie(req, 'feature_farol_theme') === 'true') {
    extraProps.farolFlags = { theme: true }
  }

  // topbar next context
  return {
    ...extraProps,
    [TOPBAR_NEXT_INTERNAL_KEY]: {
      ctx: context,
      hoc: true,
    },
  }
}
